/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded", function () {
 
    // ALKEMY CUSTOMIZATION #7 (check README) BEGIN
    const sections = document.querySelectorAll(".CustomBeforeAndAfterTabs");

    sections.forEach((section) => {
      const tabs = section.querySelectorAll(".before-after-tabs__tab");
      const panes = section.querySelectorAll(".before-after-tabs__pane");

      tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const index = tab.dataset.tabIndex;

          tabs.forEach((t) => t.classList.remove("active"));
          tab.addEventListener("click", () => {});
          tab.classList.add("active");

          panes.forEach((p) => p.classList.remove("active"));
          const pane = section.querySelector(
            `.before-after-tabs__pane[data-tab-index="${index}"]`
          );
          pane.classList.add("active");

          pane.querySelectorAll("compare-images").forEach((el) => {
            el.setOverlapImageSize();
          });
        });
      });
    });
    // ALKEMY CUSTOMIZATION #7 END

    // ALKEMY CUSTOMIZATION #8 (check README) BEGIN

  //VTO LOGIC
  const vtoContainers = document.querySelectorAll(".vto-container");

  vtoContainers.forEach((container) => {
    const modal = document.querySelector(".vto-modal");
    const toggleButton = container.querySelector(".vto-toggle-button");

    if (!modal || !toggleButton) return;

    const vtoUrl = container.getAttribute("data-vto-url");
    const productName = container.getAttribute("data-product-name");

    if (!vtoUrl || !productName) return;

    toggleButton.addEventListener("click", (event) => {
      event.stopPropagation();
      toggleModal(modal, vtoUrl, productName);
    });

    const closeButton = modal.querySelector(".vto-modal-close-button");

    closeButton.addEventListener("click", (event) => {
      event.stopPropagation();
      closeModal(modal);
    });

    document.addEventListener("click", (e) =>
      handleOutsideClick(e.target, modal, toggleButton)
    );
  });

  function closeAllModals() {
    vtoContainers.forEach((container) => {
      const modal = container.querySelector(".vto-modal");

      if (!modal || modal.classList.contains("vto-modal-invisible")) return;

      modal.classList.add("vto-modal-invisible");
      modal.querySelector(".arshades-web-3d-iframe")?.remove();
    });
  }

  function toggleModal(modal, vtoUrl, productName) {
    closeAllModals();
    const url = new URL(window.location.href);

    if (modal.classList.contains("vto-modal-invisible")) {
      url.searchParams.set("vto_used", "true");

      const previouslyUsedVto = JSON.parse(
        window.localStorage.getItem("vto_tried") || "[]"
      );
      previouslyUsedVto.push(productName);
      window.localStorage.setItem(
        "vto_tried",
        JSON.stringify(previouslyUsedVto)
      );
      window.history.replaceState({}, document.title, url.toString());

      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          attributes: {
            "VTO Data": window.localStorage.getItem("vto_tried") || "[]",
            "Arshade Data":
              window.localStorage.getItem("arshade_tried") || "[]",
          },
        }),
      })
        .then((res) => res.json())
        .catch(() => {});

      modal.appendChild(createIframe(vtoUrl));
      modal.classList.remove("vto-modal-invisible");

      const toggleButton =
        modal.closest(".vto-container")?.querySelector(".vto-toggle-button");
      const productInfo = toggleButton?.closest(".ProductInfo");
      productInfo?.classList.add("product-info-vto-active");

      return;
    }

    closeModal(modal);
  }

  function createIframe(vtoUrl) {
    const iframe = document.createElement("iframe");
    iframe.className = "arshades-web-3d-iframe";
    iframe.src = `${vtoUrl}&layout=v3`;
    iframe.allow = "camera *; web-share";
    iframe.tabIndex = 0;
    iframe.setAttribute(
      "sandbox",
      "allow-same-origin allow-scripts allow-forms"
    );
    return iframe;
  }

  function closeModal(modal) {
    const url = new URL(window.location.href);
    url.searchParams.delete("vto_used");
    window.history.replaceState({}, document.title, url.toString());

    modal.classList.add("vto-modal-invisible");
    modal.querySelector(".arshades-web-3d-iframe")?.remove();

    const toggleButton =
      modal.closest(".vto-container")?.querySelector(".vto-toggle-button");
    const productInfo = toggleButton?.closest(".ProductInfo");
    productInfo?.classList.remove("product-info-vto-active");
  }

  function handleOutsideClick(node, modal, toggleButton) {
    if (modal.contains(node) || toggleButton.contains(node)) return;

    closeModal(modal);
  }

  // ARSHADE LOGIC
  const arshadeContainers = document.querySelectorAll(".CustomArshade");

  const syncProductTryOnData = async (productName) => {
  if (!productName) return;

  try {
    // 1. Update localStorage for ARShade
    const storageKey = "arshade_tried";
    const rawData = window.localStorage.getItem(storageKey) || "[]";
    const previouslyUsedArshade = JSON.parse(rawData);
    previouslyUsedArshade.push(productName);
    window.localStorage.setItem(storageKey, JSON.stringify(previouslyUsedArshade));
    
    // 2. Prepare Cart Attributes
    const vtoData = window.localStorage.getItem("vto_tried") || "[]";
    const arShadeData = window.localStorage.getItem(storageKey) || "[]";
    // 3. Sync with Shopify Cart
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          "VTO Data": vtoData,
          "ARShade Data": arShadeData,
        },
      }),
    });

    return await response.json();
  } catch (error) {
    console.error("Failed to sync try-on data:", error);
  }
  };

  arshadeContainers.forEach((container) => {
    const toggleButton = container.querySelector(".arshade-toggle-button");
    const arshadeUrl = container.getAttribute("data-arshade-url");
    const productName = container.getAttribute("data-product-name");
    if (!toggleButton || !arshadeUrl) return;

    toggleButton.addEventListener("click", (event) => {
      event.stopPropagation();
      closeExistingModal();

      const modal = createModal(arshadeUrl);
      document.body.appendChild(modal);

      syncProductTryOnData(productName);

      const url = new URL(window.location.href);
      url.searchParams.set("arshade_used", "true");
      window.history.replaceState({}, document.title, url.toString());

      document.addEventListener("click", handleOutsideClick);
    });
  });

  document.querySelector('.arshade-toggle-link')?.addEventListener('click', () => {

    const arshadeSection = document.querySelector('#arshade');
        const url = arshadeSection.dataset.url;
        arshadeSection.querySelector('iframe').src = url;
  });

    const arshadeSection = document.querySelector('#arshade');
    const iframe = arshadeSection?.querySelector('iframe');
    const productName = arshadeSection?.getAttribute('data-product-name');
    let iframeLoaded = false;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !iframeLoaded) {
          const url = arshadeSection?.dataset.url; 
          iframe.src = url; 
          iframeLoaded = true; 
          syncProductTryOnData(productName);
          observer.unobserve(arshadeSection);
        }
      });
    }, {
      root: null,       
      threshold: 0.7     
    });

    if (arshadeSection) {
      observer.observe(arshadeSection);
    }



  // ALKEMY CUSTOMIZATION #8 END

  // ALKEMY CUSTOMIZATION #9 (check readme) BEGIN
  const buttons = document.querySelectorAll(".look__dot__button");
  const blocks = document.querySelectorAll(".CustomPictureInPicture__block");

  function closeAll() {
    blocks.forEach((block) => {
      block.classList.remove("CustomPictureInPicture__block--visible");
      block.classList.add("CustomPictureInPicture__block--invisible");
    });
  }

  buttons.forEach((button, index) => {
    button.addEventListener("click", (e) => {
      e.stopPropagation();

      const targetBlock = blocks[index];
      const isVisible = targetBlock.classList.contains(
        "CustomPictureInPicture__block--visible"
      );

      closeAll();

      if (!isVisible) {
        targetBlock.classList.remove(
          "CustomPictureInPicture__block--invisible"
        );
        targetBlock.classList.add(
          "CustomPictureInPicture__block--visible"
        );
      }
    });
  });

  document.addEventListener("click", () => {
    closeAll();
  });
  // ALKEMY CUSTOMIZATION #9 END

  // ALKEMY CUSTOMIZATION #10 (check readme) BEGIN
  (async function () {
  const GIFT_VARIANT_ID =
    window.theme?.custom?.freeProductsProduct ?? null;
  const GENDER = window.theme?.custom?.freeProductsGender ?? null;
  const THRESHOLD = parseFloat(
    window.theme?.custom?.freeProductsThreshold ?? "0"
  );
  const TAGS = window.theme?.custom?.freeProductsTags ?? null;

  if (GIFT_VARIANT_ID) {
      document.addEventListener("theme:cart:change", async () => {
      await checkGiftEligibility();
  });
  }

  if (!GIFT_VARIANT_ID || !THRESHOLD) {
    return;
  }

  async function isGiftInStock() {
    try {
      const response = await fetch(`/variants/${GIFT_VARIANT_ID}.js`);
      if (!response.ok) return false;
      
      const variant = await response.json();
      
      return variant.available;
    } catch (error) {
      console.error("Errore nel controllo stock variante:", error);
      return false;
    }
  }

  function toggleLoader() {
    const loader = document.querySelector(".Loader");
    if (!loader) return;
    loader.classList.toggle("--visible");
  }

  async function getCart() {
    const response = await fetch("/cart.js");
    return response.json();
  }

  async function addGiftToCart() {
    const cart = await getCart();
    const giftItem = cart.items.find(
      (item) => item.variant_id === GIFT_VARIANT_ID);
    const hasStock = await isGiftInStock();
    if (giftItem || !hasStock) return;
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: 1,
      }),
    });
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
    return response.json();
  }

  async function removeGiftFromCart() {
    const cart = await getCart();
    const giftItem = cart.items.find(
      (item) => item.variant_id === GIFT_VARIANT_ID
    );
    const hasStock = await isGiftInStock();
    if (giftItem || !hasStock) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: giftItem.key,
          quantity: 0,
        }),
      });
      document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
    }
  }

  async function checkGiftEligibility() {
    if (!GIFT_VARIANT_ID) return;
    const cart = await getCart();
    const hasGift = cart.items.some(
      (item) => item.variant_id === GIFT_VARIANT_ID
    );


    if (cart.item_count === 1 && hasGift && THRESHOLD > 0) {
      await removeGiftFromCart();
      return;
    }

  const requiredTagsArray = TAGS
    .split(",")
    .map(tag => tag.trim())
    .filter(tag => tag !== "");

    const detailedCartItems = await Promise.all(
        cart.items
          .filter((item) => item.variant_id !== GIFT_VARIANT_ID)
          .map(async (item) => {
            const response = await fetch(
              `/products/${item.handle}.js`
            );
            const product = await response.json();
            return { 
              ...item, 
              ...product 
            };
          })
    );

    const eligibleCartItems = detailedCartItems.filter((item) => {
      if (GENDER && !item.tags.includes(GENDER)) return;
      if (requiredTagsArray.length >= 1 && !requiredTagsArray.every(tag =>
        item.tags.includes(tag)
      )) return;
      return item;
    });

    
    const eligibleCartItemsPrice = eligibleCartItems.reduce(
      (acc, item) =>
        acc + item.final_line_price,
      0
    ) / 100;
    

    const isEligible = eligibleCartItemsPrice >= THRESHOLD;
    if (isEligible && !hasGift) {
      await addGiftToCart();
    } else if (!isEligible && hasGift) {
      await removeGiftFromCart();
    }
  }

  await checkGiftEligibility();
})();
// ALKEMY CUSTOMIZATION #10 END

// ALKEMY CUSTOMIZATION #18 (check readme) BEGIN
  function initiateSlider() {
      const sliders = document.querySelectorAll('.CustomProductGridItem__variants-slider');
      sliders?.forEach((slider) => {
        const track = slider.querySelector('.variant-slider__track');
        const items = slider.querySelectorAll('.CustomProductGridItem__variant-button');
        const prevBtn = slider.querySelector('.prev');
        const nextBtn = slider.querySelector('.next');
        let itemsPerSlide = window.innerWidth >= 750 ? 3 : 2;
        if (items.length <= itemsPerSlide) {
          track.style.justifyContent = 'center';
          prevBtn.style.visibility = 'hidden';
          nextBtn.style.visibility = 'hidden';
          }
      })
  }
  const newObserver = new MutationObserver(() => {
  const sliders = document.querySelectorAll('.CustomProductGridItem__variants-slider');
    if (sliders.length) {
      initiateSlider();
      newObserver.disconnect();
    }
  });

  newObserver.observe(document.body, { childList: true, subtree: true });
  function moveSlider(slider, direction) {
      const track = slider.querySelector('.variant-slider__track');
      const items = slider.querySelectorAll('.CustomProductGridItem__variant-button');
      if (!track || items.length === 0) return;

      let itemsPerSlide = window.innerWidth >= 750 ? 3 : 2;
      let currentIndex = parseInt(slider.dataset.currentIndex || '0');

      if (direction === 'next' && currentIndex + itemsPerSlide < items.length) {
          currentIndex++;
      } else if (direction === 'prev' && currentIndex > 0) {
          currentIndex--;
      }

      slider.dataset.currentIndex = currentIndex;
      const itemWidth = items[0].offsetWidth + 6;
      track.style.transform = `translateX(-${currentIndex * itemWidth}px)`;
      
      const prevBtn = slider.querySelector('.prev');
      const nextBtn = slider.querySelector('.next');
      if (prevBtn) prevBtn.style.visibility = currentIndex === 0 ? 'hidden' : 'visible';
      if (nextBtn) nextBtn.style.visibility = currentIndex + itemsPerSlide >= items.length ? 'hidden' : 'visible';
  }

  document.addEventListener('click', (e) => {
      const btnNext = e.target.closest('.next');
      const btnPrev = e.target.closest('.prev');

      if (btnNext) {
          const slider = btnNext.closest('.CustomProductGridItem__variants-slider');
          if (slider) {
              e.preventDefault();
              moveSlider(slider, 'next');
          }
      }

      if (btnPrev) {
          const slider = btnPrev.closest('.CustomProductGridItem__variants-slider');
          if (slider) {
              e.preventDefault();
              moveSlider(slider, 'prev');
          }
      }
  });

  const productGridObserver = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1) {
                  const sliders = node.matches('.CustomProductGridItem__variants-slider') 
                                  ? [node] 
                                  : node.querySelectorAll('.CustomProductGridItem__variants-slider');
                  
                  sliders.forEach(slider => {
                      // Imposta lo stato iniziale senza attaccare listener
                      slider.dataset.currentIndex = '0';
                      // Qui puoi nascondere i bottoni se gli item sono pochi
                      const items = slider.querySelectorAll('.CustomProductGridItem__variant-button');
                      const itemsPerSlide = window.innerWidth >= 750 ? 3 : 2;
                      if (items.length <= itemsPerSlide) {
                          const track = slider.querySelector('.variant-slider__track');
                          if (track) track.style.justifyContent = 'center';
                          const next = slider.querySelector('.next');
                          const prev = slider.querySelector('.prev');
                          if(next) next.style.visibility = 'hidden';
                          if(prev) prev.style.visibility = 'hidden';
                      }
                  });
              }
          });
      });
  });

  productGridObserver.observe(document.body, { childList: true, subtree: true });
// ALKEMY CUSTOMIZATION #18 END

// ALKEMY CUSTOMIZATION #20 (check readme) BEGIN
  const productImagesContainers = document.querySelectorAll('.CustomProductImages');
  if (!productImagesContainers) return;
  if (productImagesContainers) {
    productImagesContainers.forEach((productImageContainer) => {
      const productThumbs = productImageContainer.querySelectorAll('.product__thumb');
      const productMedias = productImageContainer.querySelectorAll('.product__slide');
      productMedias[0].classList.add('--first-row');
      return productThumbs.forEach((productThumb, productThumbIndex) => {
        return productThumb.addEventListener('click', () => {
          if (productThumb.classList.contains('is-active')) {
            productMedias.forEach((media, mediaIndex) => {
              if (mediaIndex === productThumbIndex) {
                media.classList.add('--first-row');
              } else {
                media.classList.remove('--first-row');
              }
            })
          }
        })
      })
    })
  }
// ALKEMY CUSTOMIZATION #20 END

// ALKEMY CUSTOMIZATION #18 (check readme) BEGIN
  document.addEventListener('click', function (e) {
  const button = e.target.closest('.CustomProductGridItem__variant-button');
  if (!button) return;

  e.preventDefault();

  const variantId = button.getAttribute('data-variant-id');
  const productHandle = button.getAttribute('data-handle');
  const variantImage = button.getAttribute('data-swatch-image');
  const variant = JSON.parse(button.getAttribute('data-variant-json'));
  const productCard = button.closest('[data-grid-item]');
  if (!productCard) return;

  // 1. Handle Links
  const links = productCard.querySelectorAll('a.product-link, [data-product-link]');
  links.forEach(link => {
    let baseUrl = link.getAttribute('href').split('?')[0];
    link.setAttribute('href', `${baseUrl}?variant=${variantId}`);
  });

  const quickAddToCart = productCard.querySelector('.quick-add__holder');
  quickAddToCart?.addEventListener('click', () => {
    setTimeout(() => {      
      const correspondingAddToCartDrawer = document.querySelector(`[data-product-handle="${productHandle}"]`);
      if (correspondingAddToCartDrawer) {
        const colorVariantButtonsContainer = correspondingAddToCartDrawer?.querySelector('.radio__buttons') 
        const colorVariantButtons = colorVariantButtonsContainer?.querySelectorAll('.radio__button');
        colorVariantButtons.forEach((button) => {
          const input = button?.querySelector('input');
          if (input?.value == variant?.option1) {
            publish(theme.PUB_SUB_EVENTS.optionValueSelectionChange, {
              data: {
                event: { target: input }, // The element that "changed"
                target: input,
                selectedOptionValues: [input?.getAttribute('data-option-value-id')], // The array of IDs
              }
            });
          } 
        })
      }
    }, 400);
  })

  // 2. Handle Image Transition
  if (variantImage) {
    const imageContainer = productCard.querySelector('.product-item__bg');
    const mainImg = imageContainer.querySelector('img');

    if (mainImg) {
      // Start Fade Out
      imageContainer.classList.add('is-loading');
      
      // Wait for the opacity transition (300ms matches the CSS)
      setTimeout(() => {
        // Swap the image source
        mainImg.setAttribute('srcset', variantImage);
        mainImg.setAttribute('src', variantImage);

        // Once the new image source is set, fade it back in
        // Using another timeout or img.onload ensures the swap happened
        mainImg.onload = () => {
          imageContainer.classList.remove('is-loading');
        };
        
        // Fallback in case onload doesn't fire (e.g. cached)
        setTimeout(() => imageContainer.classList.remove('is-loading'), 100);
      }, 300); 
    }
  }

  // 3. UI Active State
  productCard.querySelectorAll('.CustomProductGridItem__variant-button').forEach(btn => {
    btn.classList.remove('is-active');
  });
  button.classList.add('is-active');
  });
// ALKEMY CUSTOMIZATION #18 END


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
});

  // ALKEMY CUSTOMIZATION #57 (check README) BEGIN
  var giftBoxCartBusy = false;

  function giftBoxControl(form) {
    if (!form) return null;
    var scope = form.closest("product-info") || form.closest("[data-section-id]");
    if (scope) {
      var inScope = scope.querySelector("[data-gift-box-upsell]");
      if (inScope) return inScope;
    }
    var inside = form.querySelector("[data-gift-box-upsell]");
    if (inside) return inside;
    if (!form.id || !window.CSS || !CSS.escape) return null;
    return document.querySelector('[data-gift-box-upsell][form="' + CSS.escape(form.id) + '"]');
  }

  function giftBoxAddUrl() {
    var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || "/cart/add";
    if (url.slice(-3) !== ".js") url += ".js";
    return url;
  }

  var giftBoxAddLock = false;

  function addProductWithGiftBox(form, button, checkbox) {
    if (giftBoxAddLock || !checkbox || !checkbox.checked || checkbox.disabled) return false;
    var giftVariantId = checkbox.getAttribute("data-gift-box-variant");
    if (!giftVariantId) return false;
    if (form && !form.checkValidity()) return false;

    var formData = new FormData(form);
    var variantId = formData.get("id");
    if (!variantId) return false;

    giftBoxAddLock = true;

    var quantity = Math.max(1, parseInt(formData.get("quantity"), 10) || 1);
    var properties = propertiesFromForm(formData);
    var giftSku = checkbox.getAttribute("data-gift-box-sku");
    if (giftSku) properties._pair_id = giftSku;
    applyGiftBoxCheckoutNote(properties, checkbox);

    var productItem = {
      id: Number(variantId),
      quantity: quantity,
      properties: properties,
    };
    var sellingPlan = formData.get("selling_plan");
    if (sellingPlan) productItem.selling_plan = sellingPlan;

    if (button) {
      button.classList.add("is-loading");
      button.disabled = true;
    }
    setGiftBoxCartLoading(true);
    var giftProperties = {};
    if (giftSku) giftProperties._pair_id = giftSku;

    fetch(giftBoxAddUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [
          productItem,
          {
            id: Number(giftVariantId),
            quantity: quantity,
            properties: giftProperties,
          },
        ],
      }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        giftBoxAddLock = false;
        if (button) button.classList.remove("is-loading");
        if (!result.ok || (result.data && result.data.status)) {
          if (button) button.disabled = false;
          setGiftBoxCartLoading(false);
          if (button) showGiftBoxAddError(button, result.data || {});
          if (button) {
            button.dispatchEvent(
              new CustomEvent("theme:product:add-error", {
                detail: { response: result.data, button: button },
                bubbles: true,
              })
            );
          }
          return;
        }

        if (window.theme.settings.cartType === "page") {
          window.location = window.theme.routes.cart_url;
          return;
        }

        if (button) {
          button.dispatchEvent(
            new CustomEvent("theme:product:add", {
              detail: { response: result.data, button: button },
              bubbles: true,
            })
          );
        }
        document.dispatchEvent(new CustomEvent("theme:cart:refresh"));
      })
      .catch(function () {
        giftBoxAddLock = false;
        if (button) {
          button.classList.remove("is-loading");
          button.disabled = false;
        }
        setGiftBoxCartLoading(false);
      });

    return true;
  }

  function setGiftBoxCartLoading(isLoading) {
    document.querySelectorAll("cart-drawer, [data-cart-page]").forEach(function (element) {
      element.classList.toggle("is-loading", isLoading);
    });
  }

  function refreshGiftBoxCart() {
    document.addEventListener(
      "theme:cart:change",
      function () {
        giftBoxCartBusy = false;
      },
      { once: true }
    );
    window.setTimeout(function () {
      giftBoxCartBusy = false;
    }, 4000);
    document.dispatchEvent(new CustomEvent("theme:cart:refresh"));
  }

  function updateGiftBoxLines(updates) {
    if (giftBoxCartBusy || !window.theme || !window.theme.routes) return;
    giftBoxCartBusy = true;
    setGiftBoxCartLoading(true);

    fetch(window.theme.routes.cart_update_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function () {
        refreshGiftBoxCart();
      })
      .catch(function () {
        refreshGiftBoxCart();
      });
  }

  function propertiesFromForm(formData) {
    var properties = {};
    formData.forEach(function (value, name) {
      var match = name.match(/^properties\[(.*)\]$/);
      if (match && value !== "") properties[match[1]] = value;
    });
    return properties;
  }

  function showGiftBoxAddError(button, data) {
    var holder = button.closest("[data-section-id]") || button.closest("form");
    var errorContainer = holder && holder.querySelector("[data-cart-errors-container]");
    if (!errorContainer) return;
    var message = data && data.description ? data.description : data && data.message ? data.message : "";
    if (data && data.message && data.description && data.message !== data.description) {
      message = data.message + ": " + data.description;
    }
    errorContainer.innerHTML = '<div class="errors">' + message + "</div>";
    errorContainer.classList.add("is-visible");
  }

  document.addEventListener(
    "change",
    function (event) {
      var cartOffer = event.target.closest("[data-gift-box-cart-add]");
      if (cartOffer) {
        event.stopPropagation();
        if (!cartOffer.checked) return;
        addGiftBoxToCartLine(cartOffer);
        return;
      }

      var cartRemove = event.target.closest("[data-gift-box-cart-remove]");
      if (!cartRemove) return;
      event.stopPropagation();
      if (cartRemove.checked) return;
      var giftKey = cartRemove.getAttribute("data-id");
      if (!giftKey || giftBoxCartBusy) {
        cartRemove.checked = true;
        return;
      }
      cartRemove.disabled = true;
      var pairedItem = cartRemove.closest("[data-item]");
      var pairedKey = pairedItem && pairedItem.getAttribute("data-item");
      giftBoxCartBusy = true;
      clearGiftBoxPair(pairedKey, cartRemove.getAttribute("data-gift-box-checkout-label")).finally(function () {
        giftBoxCartBusy = false;
        var giftUpdates = {};
        giftUpdates[giftKey] = giftBoxQuantityAfterRelease(pairedItem);
        updateGiftBoxLines(giftUpdates);
      });
    },
    true
  );

  function openCheckedGiftBoxAccordions() {
    document.querySelectorAll("[data-gift-box-upsell]").forEach(function (giftCheckbox) {
      if (!giftCheckbox.checked) return;
      var giftDetails = giftCheckbox.closest("details");
      if (giftDetails) giftDetails.open = true;
    });
  }

  openCheckedGiftBoxAccordions();
  document.addEventListener("DOMContentLoaded", openCheckedGiftBoxAccordions);
  window.addEventListener("pageshow", openCheckedGiftBoxAccordions);
  window.addEventListener("load", function () {
    openCheckedGiftBoxAccordions();
    window.setTimeout(openCheckedGiftBoxAccordions, 0);
  });

  document.addEventListener("change", function (event) {
    var giftCheckbox = event.target.closest("[data-gift-box-upsell]");
    if (!giftCheckbox) return;
    var giftDetails = giftCheckbox.closest("details");
    if (!giftDetails || !giftDetails.hasAttribute("data-gift-box-keep-open")) return;
    if (giftCheckbox.checked) giftDetails.open = true;
  });

  document.addEventListener(
    "click",
    function (event) {
      var giftSummary = event.target.closest(".gift-box-upsell__heading");
      if (!giftSummary) return;
      var giftDetails = giftSummary.closest("details");
      if (!giftDetails || !giftDetails.hasAttribute("data-gift-box-keep-open")) return;
      var giftCheckbox = giftDetails.querySelector("[data-gift-box-upsell]");
      if (!giftCheckbox || !giftCheckbox.checked || !giftDetails.open) return;
      event.preventDefault();
    },
    true
  );

  document.addEventListener("change", function (event) {
    var select = event.target.closest("[data-gift-box-variant-select]");
    if (!select) return;
    var root = select.closest("[data-gift-box-upsell-root]");
    var checkbox = root && root.querySelector("[data-gift-box-upsell]");
    var option = select.options[select.selectedIndex];
    if (!checkbox || !option) return;
    checkbox.setAttribute("data-gift-box-variant", option.value);
    checkbox.setAttribute("data-gift-box-sku", option.getAttribute("data-sku") || "");
    checkbox.disabled = option.disabled;
    if (option.disabled) checkbox.checked = false;
    var price = root.querySelector("[data-gift-box-price]");
    if (price) price.textContent = option.getAttribute("data-price") || "";
  });

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || !form.hasAttribute || !form.hasAttribute("data-product-form")) return;
      if (form.querySelector('[type="file"]')) return;
      var button = form.querySelector("[data-add-to-cart]") || form.querySelector('[type="submit"]');
      if (!button || button.hasAttribute("disabled")) return;
      var checkbox = giftBoxControl(form);
      if (!addProductWithGiftBox(form, button, checkbox)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    "theme:cart:add",
    function (event) {
      var button = event.detail && event.detail.button;
      if (!button || button.hasAttribute("disabled")) return;
      var form = button.form || button.closest("form");
      if (!form || form.querySelector('[type="file"]')) return;
      var checkbox = giftBoxControl(form);
      if (!addProductWithGiftBox(form, button, checkbox)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    "theme:cart:update",
    function (event) {
      var item = event.target.closest("[data-item]");
      if (!item) return;
      var giftKey = item.getAttribute("data-gift-box-line");
      var parentKey = item.getAttribute("data-item");
      if (!giftKey || !parentKey || !event.detail) return;
      var quantity = parseInt(event.detail.quantity, 10);
      if (Number.isNaN(quantity)) return;
      event.preventDefault();
      event.stopPropagation();
      var parentQty = parseInt(item.getAttribute("data-quantity"), 10) || 0;
      var giftQty = parseInt(item.getAttribute("data-gift-box-quantity"), 10) || 0;
      var updates = {};
      updates[parentKey] = quantity;
      updates[giftKey] = Math.max(0, giftQty - parentQty + quantity);
      updateGiftBoxLines(updates);
    },
    true
  );

  function giftBoxRoute(name, fallback) {
    var url = (window.theme && window.theme.routes && window.theme.routes[name]) || fallback;
    if (url.slice(-3) !== ".js") url += ".js";
    return url;
  }

  function giftBoxReadJson(response) {
    return response.json().then(function (data) {
      return { ok: response.ok, data: data };
    });
  }

  function addGiftBoxToCartLine(button) {
    if (giftBoxAddLock || giftBoxCartBusy) {
      if (button.type === "checkbox") button.checked = false;
      return;
    }
    var variantId = button.getAttribute("data-variant-id");
    var lineKey = button.getAttribute("data-line-key");
    var giftSku = button.getAttribute("data-gift-box-sku") || "";
    var quantity = Math.max(1, parseInt(button.getAttribute("data-quantity"), 10) || 1);
    if (!variantId || !lineKey) {
      if (button.type === "checkbox") button.checked = false;
      return;
    }

    giftBoxAddLock = true;
    giftBoxCartBusy = true;
    button.disabled = true;
    button.classList.add("is-loading");
    setGiftBoxCartLoading(true);

    var previousProperties = {};
    var previousKeys = [];
    var parentQuantity = quantity;
    var changedLineKey = lineKey;
    var parentUpdated = false;

    function failGiftBoxCartAdd() {
      giftBoxAddLock = false;
      giftBoxCartBusy = false;
      button.disabled = false;
      button.classList.remove("is-loading");
      if (button.type === "checkbox") button.checked = false;
      setGiftBoxCartLoading(false);
    }

    fetch(giftBoxRoute("cart_url", "/cart"))
      .then(giftBoxReadJson)
      .then(function (result) {
        if (!result.ok) throw new Error("cart");
        previousKeys = (result.data.items || []).map(function (item) {
          return item.key;
        });
        var line = (result.data.items || []).filter(function (item) {
          return item.key === lineKey;
        })[0];
        if (!line) throw new Error("line");
        parentQuantity = line.quantity;
        var properties = {};
        var current = line.properties || {};
        Object.keys(current).forEach(function (name) {
          if (name === "_gift_box_key" || name === "_gift_box_for") return;
          if (current[name] != null && current[name] !== "") {
            properties[name] = String(current[name]);
            previousProperties[name] = String(current[name]);
          }
        });
        if (giftSku) properties._pair_id = giftSku;
        applyGiftBoxCheckoutNote(properties, button);
        console.log("Adding gift box to cart line. Previous properties:", previousProperties, giftSku, variantId);
        return fetch(giftBoxRoute("cart_change_url", "/cart/change"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: line.quantity,
            properties: properties,
          }),
        }).then(giftBoxReadJson);
      })
      .then(function (result) {
        if (!result.ok || (result.data && (result.data.status || result.data.errors))) throw new Error("change");
        var updated = (result.data.items || []).filter(function (item) {
          return previousKeys.indexOf(item.key) === -1 && item.properties && String(item.properties._pair_id) === giftSku;
        })[0];
        if (updated) changedLineKey = updated.key;
        parentUpdated = true;
        return fetch(giftBoxAddUrl(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: quantity,
                properties: {
                  _pair_id: giftSku,
                }
              },
            ],
          }),
        }).then(giftBoxReadJson);
      })
      .then(function (result) {
        if (!result.ok || (result.data && result.data.status)) throw new Error("add");
        giftBoxAddLock = false;
        refreshGiftBoxCart();
      })
      .catch(function () {
        var revert = parentUpdated
          ? fetch(giftBoxRoute("cart_change_url", "/cart/change"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                id: changedLineKey,
                quantity: parentQuantity,
                properties: previousProperties,
              }),
            })
          : Promise.resolve();
        revert.finally(failGiftBoxCartAdd);
      });
  }

  function giftBoxQuantityAfterRelease(parentItem) {
    if (!parentItem) return 0;
    var parentQty = parseInt(parentItem.getAttribute("data-quantity"), 10) || 0;
    var giftQty = parseInt(parentItem.getAttribute("data-gift-box-quantity"), 10) || 0;
    return Math.max(0, giftQty - parentQty);
  }

  function applyGiftBoxCheckoutNote(properties, element) {
    if (!element) return;
    var noteName = element.getAttribute("data-gift-box-checkout-label");
    var noteValue = element.getAttribute("data-gift-box-checkout-value");
    if (noteName && noteValue) {
      properties[noteName] = noteValue;
      properties._gift_box_checkout_label = noteName;
    }
  }

  function clearGiftBoxPair(parentKey, noteName) {
    if (!parentKey) return Promise.resolve();

    return fetch(giftBoxRoute("cart_url", "/cart.js"))
      .then(giftBoxReadJson)
      .then(function (result) {
        if (!result || !result.ok) return;

        var line = (result.data.items || []).filter(function (item) {
          return item.key === parentKey;
        })[0];

        if (!line || !line.properties) return;

        var storedNoteName = line.properties._gift_box_checkout_label || noteName;

        if (!line.properties._pair_id && !(storedNoteName && line.properties[storedNoteName])) return;

        var updatedProperties = {};

        // 1. Manteniamo le properties esistenti valide
        Object.keys(line.properties).forEach(function (name) {
          var isRemovedKey = 
            name === "_pair_id" ||
            name === "_gift_box_key" ||
            name === "_gift_box_for" ||
            name === "_gift_box_checkout_label" ||
            (storedNoteName && name === storedNoteName);

          if (isRemovedKey) {
            // In Shopify /cart/change.js, per rimuovere una property va passata come stringa vuota
            updatedProperties[name] = "";
          } else if (line.properties[name] != null && line.properties[name] !== "") {
            updatedProperties[name] = String(line.properties[name]);
          }
        });



        return fetch(giftBoxRoute("cart_change_url", "/cart/change.js"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          body: JSON.stringify({
            id: parentKey,
            quantity: line.quantity,
            properties: updatedProperties,
          }),
        });
      });
  }

  document.addEventListener(
    "click",
    function (event) {
      var giftRemove = event.target.closest("[data-gift-box-remove]");
      if (giftRemove) {
        event.preventDefault();
        event.stopPropagation();
        var giftKey = giftRemove.getAttribute("data-id");
        if (!giftKey || giftBoxCartBusy) return;
        var pairedItem = giftRemove.closest("[data-item]");
        var pairedKey = pairedItem && pairedItem.getAttribute("data-item");
        giftBoxCartBusy = true;
        clearGiftBoxPair(pairedKey, giftRemove.getAttribute("data-gift-box-checkout-label")).finally(function () {
          giftBoxCartBusy = false;
          var giftUpdates = {};
          giftUpdates[giftKey] = giftBoxQuantityAfterRelease(pairedItem);
          updateGiftBoxLines(giftUpdates);
        });
        return;
      }

      var removeButton = event.target.closest("[data-item-remove]");
      if (!removeButton) return;
      var parentItem = removeButton.closest("[data-item]");
      var linkedGiftKey = parentItem && parentItem.getAttribute("data-gift-box-line");
      if (!linkedGiftKey) return;
      event.preventDefault();
      event.stopPropagation();
      var parentKey = removeButton.getAttribute("data-id");
      if (!parentKey) return;
      var updates = {};
      updates[parentKey] = 0;
      updates[linkedGiftKey] = giftBoxQuantityAfterRelease(parentItem);
      updateGiftBoxLines(updates);
    },
    true
  );
  // ALKEMY CUSTOMIZATION #57 END
})();